import { render, staticRenderFns } from "./IbotechContainer.vue?vue&type=template&id=bb42aa1c&"
import script from "./IbotechContainer.vue?vue&type=script&lang=ts&"
export * from "./IbotechContainer.vue?vue&type=script&lang=ts&"
import style0 from "./IbotechContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports